export const GET_SITES = 'GET_SITES';
export const GET_SITES_ERROR = 'GET_SITES_ERROR';
export const GET_TEACHERS = 'GET_TEACHERS';
export const GET_TEACHERS_ERROR = 'GET_TEACHERS_ERROR';
export const GET_TEACHERS_REPORT = 'GET_TEACHERS_REPORT';
export const GET_TEACHERS_REPORT_ERROR = 'GET_TEACHERS_REPORT_ERROR';
export const TEACHER_REPORT_LOAD = 'TEACHER_REPORT_LOAD';
export const TEACHERS_LOAD = 'TEACHERS_LOAD';
export const CLEAR_REPORT_DATA = 'CLEAR_REPORT_DATA';



// WEBPACK FOOTER //
// ./src/pages/teacherrolls/state/types.js